import { render } from "./UserSection.component.vue?vue&type=template&id=e5b2be3e&scoped=true&ts=true"
import script from "./UserSection.component.vue?vue&type=script&lang=ts"
export * from "./UserSection.component.vue?vue&type=script&lang=ts"

import "./UserSection.component.vue?vue&type=style&index=0&id=e5b2be3e&scoped=true&lang=scss"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b2be3e"]])

export default __exports__